import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";
import Text from "@/shared-components/text/components/Text";

import "./styles/PopUpConfirmDeleteDraft.css";

const PopUpConfirmDeleteDraft = ({
  onConfirm,
  open,
  close,
  draftName = "this draft",
}) => {  
  return (
    <GenericPopup
      open={open}
      className="popup-confirm-draft-delete-container__popup"
      opacity
    >
      <div className="popup-confirm-draft-delete-container relative">
        <div className="popup-confirm-draft-delete-header">
          <Text className="popup-confirm-draft-delete-header-text">
            Delete Draft
            <XIcon className="popup-confirm-draft-delete-close" onClick={close} />
          </Text>
        </div>

        <Text className="popup-confirm-draft-delete-text">
          {`Are you sure you want to delete `}
          <span className="popup-confirm-draft-delete_draftname_theme">{draftName}</span>
          {` ?`}
        </Text>
      </div>
      <div className="popup-confirm-draft-delete_buttons">
        <ContinueButton 
          onClick={(event) => {
            onConfirm(event);
            close();
          }} 
          medium
        >
          Yes, delete it
        </ContinueButton>
      </div>
    </GenericPopup>
  );
};

export default PopUpConfirmDeleteDraft;
